"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Subscription = exports.ProductSection = exports.ProductDescription = exports.ProductLogo = exports.ActivationContent = exports.SUBSCRIPTION_TYPE = void 0;

var _react = _interopRequireDefault(require("react"));

var _PingdomContent = require("./PingdomContent");

var _LogglyContent = require("./LogglyContent");

var _AppOpticsContent = require("./AppOpticsContent");

var _PapertrailContent = require("./PapertrailContent");

var _DefaultContent = require("./DefaultContent");

var _Grid = _interopRequireDefault(require("../../../../components/Grid/Grid"));

var _Image = _interopRequireDefault(require("../../../../components/Image/Image"));

var _productsStatus = require("../AppSwitcher/productsStatus");

var SUBSCRIPTION_TYPE = {
  TRIAL: 'trial',
  FREE: 'free'
};
exports.SUBSCRIPTION_TYPE = SUBSCRIPTION_TYPE;

var ActivationContent = function ActivationContent(props) {
  var productStatus = props.productStatus;
  var ContentComponent;
  var product = props.product;

  switch (props.product) {
    case 'appoptics':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/_react["default"].createElement(_AppOpticsContent.AppOpticsContent, {
          productStatus: productStatus
        });
      };

      break;

    case 'loggly':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/_react["default"].createElement(_LogglyContent.LogglyContent, {
          productStatus: productStatus
        });
      };

      break;

    case 'papertrail':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/_react["default"].createElement(_PapertrailContent.PapertrailContent, {
          productStatus: productStatus
        });
      };

      break;

    case 'pingdom':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/_react["default"].createElement(_PingdomContent.PingdomContent, {
          productStatus: productStatus
        });
      };

      break;

    default:
      product = 'default';
      ContentComponent = _DefaultContent.DefaultContent;
      break;
  }

  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    centered: true,
    "data-qa-content": product,
    "data-qa": "activation-content",
    className: "activation-content"
  }, /*#__PURE__*/_react["default"].createElement(ContentComponent, null));
};

exports.ActivationContent = ActivationContent;

var ProductLogo = function ProductLogo(_ref) {
  var logo = _ref.logo;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    src: logo,
    className: "logo"
  }));
};

exports.ProductLogo = ProductLogo;

var ProductDescription = function ProductDescription(_ref2) {
  var title = _ref2.title,
      content = _ref2.content;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, {
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "title"
  }, title)), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, {
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content"
  }, content)));
};

exports.ProductDescription = ProductDescription;

var ProductSection = function ProductSection(_ref3) {
  var image = _ref3.image,
      title = _ref3.title,
      content = _ref3.content;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Column, {
    computer: 5,
    mobile: 16,
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    src: image,
    className: "section-image"
  }), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "section-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "section-content"
  }, content));
};

exports.ProductSection = ProductSection;

var Subscription = function Subscription(_ref4) {
  var productName = _ref4.productName,
      productStatus = _ref4.productStatus,
      type = _ref4.type;

  if (productStatus === _productsStatus.PRODUCT_STATUS.CAN_ACTIVATE) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "subscription",
      "data-qa": "subscription"
    }, /*#__PURE__*/_react["default"].createElement(SubscriptionIntroductionText, {
      productName: productName,
      type: type
    }), /*#__PURE__*/_react["default"].createElement(SubscriptionMainText, {
      type: type
    }), /*#__PURE__*/_react["default"].createElement("br", null), "You will not be charged unless you choose to continue with a paid account."));
  }

  return null;
};

exports.Subscription = Subscription;

var SubscriptionIntroductionText = function SubscriptionIntroductionText(_ref5) {
  var productName = _ref5.productName,
      type = _ref5.type;
  var trialDays = productName === 'loggly' ? 30 : 14;
  if (type === SUBSCRIPTION_TYPE.TRIAL) return /*#__PURE__*/_react["default"].createElement("strong", null, "Try for ", trialDays, " days! ");
  if (type === SUBSCRIPTION_TYPE.FREE) return /*#__PURE__*/_react["default"].createElement("strong", null, "Try for Free! ");
  return null;
};

var SubscriptionMainText = function SubscriptionMainText(_ref6) {
  var type = _ref6.type;
  if (type === SUBSCRIPTION_TYPE.TRIAL) return 'During the trial you can try all features, change plan or cancel at any time.';
  if (type === SUBSCRIPTION_TYPE.FREE) return 'You can try all features, change plan or cancel at any time.';
  return null;
};